
//	Validate email (Super naive on purpose ref: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript)
const validateEmail = (email) => {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	return re.test(email)
}

export default validateEmail



// WEBPACK FOOTER //
// ./src/utilities/validateEmail.js